const BulkEditColumns = [
  {
    title: 'No.',
    dataIndex: 'index',
    width: '80px'
  },
  {
    title: 'Webpage URL',
    dataIndex: 'url',
    slot: 'webpageUrl'
  },
  {
    title: 'Plan Type',
    dataIndex: 'plan_type',
    slot: 'planType'
  },
  {
    title: 'Polling Interval',
    dataIndex: 'polling_interval',
    slot: 'pollingInterval'
  }
];

export { BulkEditColumns };

